import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";

export function AdminLoading() {
  return (
    <div className="min-h-screen bg-[#0A2540] grid place-items-center" data-testid="admin-loading">
      <Loader2 size={32} className="animate-spin text-white/70" />
    </div>
  );
}

export function AdminLogin({ onLogin, loading, error }) {
  const [input, setInput] = useState("");
  return (
    <div className="min-h-screen bg-[#0A2540] grid place-items-center px-6 font-body" data-testid="admin-login">
      <div className="w-full max-w-sm bg-white rounded-[2rem] p-8 shadow-2xl">
        <span className="grid place-items-center w-14 h-14 rounded-2xl bg-[#FF7A1A] text-white mb-6"><Lock size={24} /></span>
        <h1 className="font-heading text-2xl font-bold text-[#0F172A]">Enquiries Admin</h1>
        <p className="mt-2 text-[#64748B]">Enter your admin key to view website enquiries.</p>
        <form onSubmit={(e) => { e.preventDefault(); onLogin(input.trim()); }} className="mt-6 space-y-4">
          <input
            type="password"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Admin key"
            className="w-full bg-[#F8FAFC] border border-slate-200 rounded-2xl px-5 py-3.5 focus:outline-none focus:border-[#FF7A1A] transition-all"
            data-testid="admin-key-input"
          />
          {error && <p className="text-sm text-red-500" data-testid="admin-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#FF7A1A] text-white font-bold px-8 py-3.5 rounded-full hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-60"
            data-testid="admin-login-btn"
          >
            {loading ? "Checking..." : "View enquiries"}
          </button>
        </form>
      </div>
    </div>
  );
}
